<div class="metrics-tab mopView">

  <!-- ── Filter row ─────────────────────────────────────────── -->
  <div class="cardStack metrics-filter-row" id="filterCard">
    <span class="filtertitle">Filters</span>

    <div class="filter-chips-wrap">
      <mat-chip-listbox class="time-range-chips" aria-label="DatePicker">
        <mat-chip-option (click)="updateStart('1h')"  [selected]="dateFilter === '1h'">1h</mat-chip-option>
        <mat-chip-option (click)="updateStart('6h')"  [selected]="dateFilter === '6h'">6h</mat-chip-option>
        <mat-chip-option (click)="updateStart('24h')" [selected]="dateFilter === '24h'">24h</mat-chip-option>
        <mat-chip-option (click)="updateStart('3d')"  [selected]="dateFilter === '3d'">3d</mat-chip-option>
        <mat-chip-option (click)="updateStart('7d')"  [selected]="dateFilter === '7d'">7d</mat-chip-option>
      </mat-chip-listbox>
    </div>

    <div id="resource-filter">
      @if (filterValue) {
        <mat-chip-listbox>
          <mat-chip-option selected [matTooltip]="model.name" matTooltipPosition="above">{{ model.name | truncate: 16 }}</mat-chip-option>
        </mat-chip-listbox>
      }
    </div>

    <div class="absoluteTimeRanges">
      <app-date-time-range-picker
        [(ngModel)]="rangeDates"
        [minDate]="minimumDate"
        placeholder="Select Time Frame"
        [showButtonBar]="true"
        (ngModelChange)="closeCalendar()"
      ></app-date-time-range-picker>
    </div>
  </div>

  <!-- ── Two-column body ────────────────────────────────────── -->
  <div class="metrics-content-row">

    <!-- Left column: utilization box + usage tables -->
    <div class="metrics-left-col">

      @if (resourceType !== 'edge-router') {
        <div class="cardStack" style="height: 9.375rem">
          <mat-tab-group class="darkMode" dynamicHeight mat-align-tabs="start">
            <mat-tab>
              <ng-template mat-tab-label>
                <span class="title nobottom">Utilization Total</span>
              </ng-template>
              <app-utilization-totals-box
                [aggregateField]="templateService.usage_aggregate_field"
                [dateFilter]="dateFilter"
                [filterField]="filterType"
                [filterValue]="filterValue"
                [label]="'Total Utilization'"
                [networkId]="networkId"
                [newEndTime]="endTime"
                [newStartTime]="startTime"
                [organizationId]="networkGroupId"
              ></app-utilization-totals-box>
            </mat-tab>
          </mat-tab-group>
        </div>
      }

      @if (resourceType === 'service') {
        <div class="cardStack" style="height: 12.375rem">
          <mat-tab-group class="darkMode" dynamicHeight mat-align-tabs="start">
            <mat-tab>
              <ng-template mat-tab-label>
                <span class="title nobottom">Service Dial Health</span>
              </ng-template>
              <app-service-health-pie
                [dateFilter]="dateFilter"
                [networkGroupId]="networkGroupId"
                [networkId]="networkId"
                [serviceId]="model.id"
                [height]="apiService.remToPx(15.625) + 'px'"
              ></app-service-health-pie>
            </mat-tab>
          </mat-tab-group>
        </div>
      }

      @if (resourceType !== 'endpoint') {
        <div class="cardStack metrics-fill-card">
          @if (endpointItems) {
            <div (click)="downloadEndpointCsv()" class="metricDownload buttonAction export" id="downloadEndpointcsv"></div>
          }
          <mat-tab-group class="darkMode" dynamicHeight mat-align-tabs="start">
            <mat-tab>
              <ng-template mat-tab-label>
                <span class="title nobottom">{{ labelEndpoint }}</span>
              </ng-template>
              <div>
                <app-ziti-utilization-table
                  (dataReceived)="receivedEndpointItems($event)"
                  [dateFilter]="dateFilter"
                  [filterField]="filterType"
                  [filterValue]="filterValue"
                  [networkId]="networkId"
                  [newEndTime]="endTime"
                  [newStartTime]="startTime"
                  [organizationId]="networkGroupId"
                  [selectedAttributes]="[]"
                  [aggregateField]="templateService.identity_aggregate_field"
                  [nameTruncateLength]="25"
                ></app-ziti-utilization-table>
              </div>
            </mat-tab>
            @if (hostingEndpointData) {
              <mat-tab>
                <ng-template mat-tab-label>
                  <span class="title nobottom">{{ usageHostingLabel }}</span>
                </ng-template>
                <div>
                  <app-ziti-utilization-table
                    (dataReceived)="receivedEndpointItems($event)"
                    [filterField]="filterType"
                    [filterValue]="filterValue"
                    [networkId]="currentNetwork?.id"
                    [newEndTime]="endTime"
                    [newStartTime]="startTime"
                    [organizationId]="currentNetwork?.networkGroupId"
                    [selectedAttributes]="[]"
                    [aggregateField]="templateService.host_aggregate_field"
                    [nameTruncateLength]="25"
                  ></app-ziti-utilization-table>
                </div>
              </mat-tab>
            }
          </mat-tab-group>
        </div>
      }

      @if (resourceType !== 'service') {
        <div class="cardStack metrics-fill-card">
          @if (serviceItems) {
            <div (click)="downloadServiceCsv()" class="metricDownload buttonAction export" id="downloadServicecsv"></div>
          }
          <mat-tab-group class="darkMode" dynamicHeight mat-align-tabs="start">
            <mat-tab>
              <ng-template mat-tab-label>
                <span class="title nobottom">Usage By Service</span>
              </ng-template>
              <div>
                <app-ziti-utilization-table
                  (dataReceived)="receivedServiceItems($event)"
                  [dateFilter]="dateFilter"
                  [filterField]="filterType"
                  [filterValue]="filterValue"
                  [locked]="serviceTableLocked"
                  [networkId]="networkId"
                  [newEndTime]="endTime"
                  [newStartTime]="startTime"
                  [organizationId]="networkGroupId"
                  [selectedAttributes]="[]"
                  [aggregateField]="templateService.service_aggregate_field"
                  [nameTruncateLength]="25"
                ></app-ziti-utilization-table>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      }

    </div><!-- /metrics-left-col -->

    <!-- Right column: top usage pies + stacked usage charts -->
    <div class="metrics-right-col">

      <!-- Top Usage By Resource Type -->
      <div class="cardStack" style="height: 20.25rem">
        <mat-tab-group class="darkMode" mat-align-tabs="start" (selectedTabChange)="reflowCharts()">
          @if (resourceType === 'service') {
            <mat-tab>
              <ng-template mat-tab-label>
                <span class="title nobottom">Service Dial Health</span>
              </ng-template>
              <div>
                <ng-template matTabContent>
                  <app-service-health-timeline
                    [dateFilter]="dateFilter"
                    [height]="apiService.remToPx(15.925) + 'px'"
                    [networkGroupId]="networkGroupId"
                    [networkId]="networkId"
                    [serviceId]="model.id"
                  ></app-service-health-timeline>
                </ng-template>
              </div>
            </mat-tab>
          }
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="title nobottom">Top Usage By Resource Type</span>
            </ng-template>
            <div class="fullSized">
              <ng-template matTabContent>
                <div class="{{ topUsageGridStyleClass }}">
                  @if (resourceType !== 'endpoint') {
                    <div>
                      <app-ziti-utilization-pie-mini
                        [aggregateField]="templateService.identity_aggregate_field"
                        [dateFilter]="dateFilter"
                        [filterField]="filterType"
                        [filterValue]="filterValue"
                        [height]="apiService.remToPx(15.625) + 'px'"
                        [label]="labelEndpoint"
                        [networkId]="networkId"
                        [newEndTime]="endTime"
                        [newStartTime]="startTime"
                        [organizationId]="networkGroupId"
                        [selectedAttributes]="[]"
                      ></app-ziti-utilization-pie-mini>
                    </div>
                  }
                  @if (resourceType !== 'endpoint') {
                    <div>
                      <app-ziti-utilization-pie-mini
                        [aggregateField]="templateService.host_aggregate_field"
                        [dateFilter]="dateFilter"
                        [filterField]="filterType"
                        [filterValue]="filterValue"
                        [height]="apiService.remToPx(15.625) + 'px'"
                        [label]="label"
                        [networkId]="networkId"
                        [newEndTime]="endTime"
                        [newStartTime]="startTime"
                        [organizationId]="networkGroupId"
                        [selectedAttributes]="[]"
                      ></app-ziti-utilization-pie-mini>
                    </div>
                  }
                  @if (resourceType !== 'service') {
                    <div>
                      <app-ziti-utilization-pie-mini
                        [aggregateField]="templateService.service_aggregate_field"
                        [dateFilter]="dateFilter"
                        [filterField]="filterType"
                        [filterValue]="filterValue"
                        [height]="apiService.remToPx(15.625) + 'px'"
                        [label]="'Services'"
                        [networkId]="networkId"
                        [newEndTime]="endTime"
                        [newStartTime]="startTime"
                        [organizationId]="networkGroupId"
                        [selectedAttributes]="[]"
                      ></app-ziti-utilization-pie-mini>
                    </div>
                  }
                  @if (resourceType !== 'edge-router') {
                    <div>
                      <app-ziti-utilization-pie-mini
                        [aggregateField]="templateService.edge_router_aggregate_field"
                        [dateFilter]="dateFilter"
                        [filterField]="filterType"
                        [filterValue]="filterValue"
                        [height]="apiService.remToPx(15.625) + 'px'"
                        [label]="'Edge Routers'"
                        [networkId]="networkId"
                        [newEndTime]="endTime"
                        [newStartTime]="startTime"
                        [organizationId]="networkGroupId"
                        [selectedAttributes]="[]"
                      ></app-ziti-utilization-pie-mini>
                    </div>
                  }
                </div>
              </ng-template>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>

      <!-- Stacked usage charts -->
      <div class="cardStack" style="height: 20.25rem">
        <mat-tab-group class="darkMode" mat-align-tabs="start" (selectedTabChange)="reflowCharts()">
          @if (resourceType !== 'endpoint') {
            <mat-tab>
              <ng-template mat-tab-label>
                <span class="title nobottom">Usage By Identities</span>
              </ng-template>
              <div>
                <ng-template matTabContent>
                  <app-ziti-utilization-stacked
                    [dateFilter]="dateFilter"
                    [filterField]="filterType"
                    [filterValue]="filterValue"
                    [height]="apiService.remToPx(16.875) + 'px'"
                    [networkGroupId]="networkGroupId"
                    [networkId]="networkId"
                    [selectedAttributes]="[]"
                    [newStartTime]="startTime"
                    [newEndTime]="endTime"
                    [stackBy]="templateService.identity_aggregate_field"
                  ></app-ziti-utilization-stacked>
                </ng-template>
              </div>
            </mat-tab>
          }
          @if (resourceType !== 'service') {
            <mat-tab label="Usage By Services">
              <div>
                <ng-template matTabContent>
                  <app-ziti-utilization-stacked
                    [dateFilter]="dateFilter"
                    [filterField]="filterType"
                    [filterValue]="filterValue"
                    [height]="apiService.remToPx(16.875) + 'px'"
                    [networkGroupId]="networkGroupId"
                    [networkId]="networkId"
                    [newEndTime]="endTime"
                    [newStartTime]="startTime"
                    [selectedAttributes]="[]"
                    [stackBy]="templateService.service_aggregate_field"
                  ></app-ziti-utilization-stacked>
                </ng-template>
              </div>
            </mat-tab>
          }
          @if (resourceType !== 'edge-router') {
            <mat-tab label="Usage By {{ label }}">
              <div>
                <ng-template matTabContent>
                  <app-ziti-utilization-stacked
                    [dateFilter]="dateFilter"
                    [filterField]="filterType"
                    [filterValue]="filterValue"
                    [height]="apiService.remToPx(16.875) + 'px'"
                    [networkGroupId]="networkGroupId"
                    [networkId]="networkId"
                    [newEndTime]="endTime"
                    [newStartTime]="startTime"
                    [selectedAttributes]="[]"
                    [stackBy]="aggregateField"
                  ></app-ziti-utilization-stacked>
                </ng-template>
              </div>
            </mat-tab>
          }
          <mat-tab label="Usage By Direction">
            <div>
              <ng-template matTabContent>
                <app-ziti-utilization-basic
                  [dateFilter]="dateFilter"
                  [filterField]="filterType"
                  [filterValue]="filterValue"
                  [height]="apiService.remToPx(16.875) + 'px'"
                  [networkGroupId]="networkGroupId"
                  [networkId]="networkId"
                  [newEndTime]="endTime"
                  [newStartTime]="startTime"
                ></app-ziti-utilization-basic>
              </ng-template>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>

    </div><!-- /metrics-right-col -->

  </div><!-- /metrics-content-row -->

</div>
